// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.episodes-from-series {
    font-family: sans-serif;
    max-width: 400px;
}

.episodes-from-series ul {
    padding: 0px;
}

.episodes-from-series li {
    list-style: none;
    display: flex;
    gap: 7px;
    margin: 7px;
    max-width: 500px;
}

.episodes-from-series a {
    color: white;
    display: flex;
    border: 1px rgba(0,0,0,0) dashed;
    font-size: 0.9em;
    width: 100%
}

.episodes-from-series a:hover {
    color: grey;
    border: 1px lightsalmon dashed;
}

.episodes-from-series img {
    max-width: 120px;
    height: fit-content;
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/css/EpisodesFromSeries.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":["\n.episodes-from-series {\n    font-family: sans-serif;\n    max-width: 400px;\n}\n\n.episodes-from-series ul {\n    padding: 0px;\n}\n\n.episodes-from-series li {\n    list-style: none;\n    display: flex;\n    gap: 7px;\n    margin: 7px;\n    max-width: 500px;\n}\n\n.episodes-from-series a {\n    color: white;\n    display: flex;\n    border: 1px rgba(0,0,0,0) dashed;\n    font-size: 0.9em;\n    width: 100%\n}\n\n.episodes-from-series a:hover {\n    color: grey;\n    border: 1px lightsalmon dashed;\n}\n\n.episodes-from-series img {\n    max-width: 120px;\n    height: fit-content;\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
